import React, { memo } from 'react';
import PropTypes from 'prop-types';
import SettingsButton from "./SettingsButton";
import defaultRenderButton from "./defaultRenderButton";
import { settingsGroup, settingsGroupLabel, settingsGroupButtons } from "./classNames";
import { groupShape } from "./propTypes";
var SettingsGroup = memo(function (_ref) {
  var _ref$group = _ref.group,
      label = _ref$group.label,
      property = _ref$group.property,
      options = _ref$group.options,
      renderButton = _ref$group.renderButton,
      value = _ref.value,
      setValue = _ref.setValue;
  return React.createElement("div", {
    className: settingsGroup
  }, React.createElement("div", {
    className: settingsGroupLabel
  }, label, ":"), React.createElement("div", {
    className: settingsGroupButtons
  }, options.map(function (option) {
    return React.createElement(SettingsButton, {
      property: property,
      option: option,
      value: value,
      setValue: setValue,
      key: option.value
    }, renderButton || defaultRenderButton);
  })));
});
SettingsGroup.propTypes = {
  group: groupShape.isRequired,
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired
};
export default SettingsGroup;